import clsx from 'clsx'
import { findYoutubeId } from 'lib/utilities/string'
import { ReactNode } from 'react'
import Button from '../Button/Button'
import Header from '../Header/Header'
import YouTubeFacade from '../YouTubeFacade/YouTubeFacade'

interface VideoButton {
  text: string
  link: {
    href: string
  }
}

interface VideoProps {
  /**
   * Optional copy for header
   */
  header?: string | ReactNode
  /**
   * YouTube video URL
   */
  videoUrl: string
  /**
   * Optional copy for caption
   */
  caption?: string
  /**
   * Copy for body
   */
  body?: string
  /**
   * Copy and URL for button
   */
  button?: VideoButton
  /**
   * Optional additional class names
   */
  className?: string
  /**
   * If default classNames on wrapper should be removed
   */
  overrideClassName?: boolean
}

export default function Video({
  header,
  videoUrl,
  caption,
  body,
  button,
  className = '',
  overrideClassName,
}: VideoProps) {
  const videoId = findYoutubeId(videoUrl)

  // Convert header to string for iframe title attribute
  const headerTitle = typeof header === 'string' ? header : 'Video'

  return (
    <>
      {videoId && (
        <div
          className={clsx(overrideClassName ? className : `py-10 ${className}`)}
        >
          {header && (
            <Header as="h2" overrideClassName className="type-headline-1 mb-4">
              {header}
            </Header>
          )}
          <YouTubeFacade
            videoId={videoId}
            title={headerTitle}
            className="rounded-lg"
          />
          {caption && (
            <p className="text-neutral-600 type-body-8 mt-4">{caption}</p>
          )}
          {body && (
            <p className="mt-4 max-w-[864px] type-body-6 line-clamp-4">
              {body}
            </p>
          )}
          {button && (
            <Button
              className="[&]:text-xs [&]:lg:text-base mt-4"
              link={button.link}
            >
              {button.text}
            </Button>
          )}
        </div>
      )}
    </>
  )
}
